import { Directive, ElementRef, EventEmitter, OnDestroy, Output } from '@angular/core'

@Directive({
    selector: '[appInView]'
})

export class InViewDirective implements OnDestroy {
    @Output() inView: EventEmitter<{ inView: boolean, element: ElementRef }> = new EventEmitter<{ inView: boolean, element: ElementRef }>()
    private observer: IntersectionObserver

    constructor(private elementRef: ElementRef) {
        this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.inView.emit({ inView: true, element: this.elementRef })
                } else {
                    this.inView.emit({ inView: false, element: this.elementRef })
                }
            })
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 0.5
        })

        this.observer.observe(this.elementRef.nativeElement)
    }

    ngOnDestroy() {
        this.observer.disconnect()
    }
}